import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Col } from "reactstrap";
import { useDispatch } from "react-redux";
import {
  getRolesForTables,
  postRoleForGaId,
} from "../../../slices/admin/thunk";
import Loading from "../../../Components/Loading";
import BrokersTable from "../../../Components/Tables/BrokerTable/BrokersTable";
import AddRoleModal from "../../../Components/modals/GeneralModals/AddRoleModal";
import Swal from "sweetalert2";
import { DASHBOARD_USER_ROLES } from "../../../constants";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import DropdownActionsTable from "../../../Components/Dropdown/DropdownActionsTable";
import { downloadBrokersReportByUserId } from "../../../slices/general/thunk";
import { useCurrentUser } from "../../../slices/auth/hooks";

const DashboardBrokersGA = ({
  brokerId,
  isLoaded,
  openModal,
  setOpenModal,
}) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const isNational = currentUser?.role === DASHBOARD_USER_ROLES.NATIONAL;
  const isAdmin = currentUser?.role === DASHBOARD_USER_ROLES.ADMIN;

  const { id } = useParams();

  const [loadingCreate, setLoadingCreate] = useState(false);

  const [loading, setLoading] = useState(false);

  const [brokers, setBrokers] = useState([]);
  const [totalBrokers, setTotalBrokers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchBrokers = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: brokerId || id,
          userRole: DASHBOARD_USER_ROLES.GA,
          role: "brokers",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setBrokers(response.data);
      setTotalBrokers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoaded) {
      if (debouncedSearchTerm === lastSearchTerm) {
        setSearchDone(true);
      } else {
        setSearchDone(false);
      }
      fetchBrokers();
    }
    // fetchBrokers();
  }, [brokerId, id, dispatch, debouncedSearchTerm, currentPage]);

  const handleCreateBroker = async (values) => {
    try {
      setLoadingCreate(true);
      const response = await dispatch(
        postRoleForGaId({
          role: "brokers",
          data: values,
          id: brokerId || id,
        })
      ).unwrap();

      if (!response.error) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Broker created successfully",
          timer: 2000,
          showConfirmButton: false,
        });
        setLoadingCreate(false);
        setOpenModal(false);
        fetchBrokers();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.error || "Error creating broker",
          timer: 2000,
          showConfirmButton: false,
        });
        setLoadingCreate(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Error creating broker",
        timer: 2000,
        showConfirmButton: false,
      });
      setLoadingCreate(false);
      console.log(error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  `BaxRx | GA | Brokers`;

  return (
    <React.Fragment>
      {openModal && (
        <AddRoleModal
          open={openModal}
          setOpen={setOpenModal}
          roleToAdd={DASHBOARD_USER_ROLES.BROKER}
          onCreate={handleCreateBroker}
          loading={loadingCreate}
          forUserId={brokerId || id}
        />
      )}
      <>
        <Container fluid>
          <div className="col-12 d-flex justify-content-between mt-2 mb-3 align-items-center ">
            <div className="col-4 d-flex justify-content-end align-items-center">
              <SearchBar
                inputRef={inputRef}
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Filter by name or email"
              />
              {(isAdmin || isNational) && (
                <DropdownActionsTable
                  downloadMethod={downloadBrokersReportByUserId}
                  params={{ dashboardUserId: brokerId || id }}
                />
              )}
            </div>
          </div>

          <Col xl={12}>
            <div className="table-container  position-relative">
              {loading && <Loading />}
              <div className="live-preview">
                <div className="table-responsive ">
                  <BrokersTable
                    data={brokers}
                    searchDone={searchDone}
                    searchParam={debouncedSearchTerm}
                    paginationProps={{
                      currentPage,
                      totalPages,
                      totalItems: totalBrokers,
                      pageSize,
                      onChangePage: handleChangePage,
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Container>
      </>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardBrokersGA;
